export const Panel = ({ children }) => children
